const assetBase = '/assets/strongova'
const localAssetBase = '/src/assets'
const uploadBase = 'https://www.strongova.com/uploads/images'
const staticBase = 'https://www.strongova.com/static/images'
const customizeBase = `${assetBase}/customize`
const customizeAsset = path => `${customizeBase}/${path.replace(/^\//, '')}`
const qualityBase = `${assetBase}/quality`
const qualityAsset = name => `${qualityBase}/${name}`
const casesBase = `${assetBase}/cases`
const casesAsset = name => `${casesBase}/${name}`
const careBase = `${assetBase}/care`
const careAsset = name => `${careBase}/${name}`
const newsVideo = () => ''

export default {
  hero: {
    eyebrow: 'STRONGOVA NATURAL WOOD FLOOR',
    title: ['WALKS', 'ON', 'NATURE'],
    background: `${assetBase}/hero-bg.jpg`,
    paragraphs: [
      'Since its establishment in 2005, STRONGOVA has remained steadfast in its core commitment to "100% Ecological Wood," crafting pure solid wood composite flooring to European environmental standards. With modern production bases in China and Serbia, we bring 20 years of flooring manufacturing expertise to every product we create.',
      'As a holder of both FSC Forest Certification and EU CE Certification, STRONGOVA flooring has been installed in 10,000+ high-end residences, hotels, and commercial spaces worldwide, from minimalist Nordic villas to royal residences in the Middle East.',
      'Choosing STRONGOVA means choosing dual-region supply chain security, a 15-year warranty, full traceability, and specialized solutions for demanding environments.'
    ]
  },
  values: [
    { title: 'NATURAL', image: `${assetBase}/value-natural.png` },
    { title: 'HEALTHY', image: `${assetBase}/value-healthy.png` },
    { title: 'COMFORTABLE', image: `${assetBase}/value-comfortable.png` },
    { title: 'LONG-LASTING DURABILITY', image: `${assetBase}/value-durable.png` }
  ],
  founder: {
    title: 'The story of the founder',
    image: `${assetBase}/founder.jpg`,
    paragraphs: [
      'Heritage and Innovation: A New Chapter of STRONGOVA Solid Wood Flooring.',
      'Twenty years ago, my father, driven by his passion for wood and an artisan\'s dedication, founded his own solid wood flooring brand. Starting from a small workshop to a modern factory with over 400 employees, he used his hands and wisdom to transform raw timber into elegant, warm flooring that now graces countless homes.',
      'Craftsmanship Inherited: From Father\'s Perseverance to My Mission. My father often said, "Wood has a soul; our task is to let it continue in its most beautiful form." Under his influence, I came to understand that solid wood flooring is not merely a commodity but an art form that carries the weight of time.',
      'Breakthrough and Rebirth: The Birth of STRONGOVA. As times changed, so did consumer demands. While preserving traditional techniques, I realized solid wood flooring needed to evolve: more eco-friendly finishes, scientifically engineered structures, and designs aligned with contemporary aesthetics.',
      'Today, heritage is not about replication. It is like a tree: roots anchored deep in soil, branches stretching toward the light.'
    ]
  },
  storyVideo: {
    title: 'This is a growth story about the brand manager of STRONGOVA.',
    poster: `${assetBase}/video-poster.jpg`,
    src: ''
  },
  strength: {
    eyebrow: 'STRONGOVA Solid Wood Flooring',
    title: 'Global Craftsmanship, Uncompromising Quality',
    intro: 'In the solid wood flooring industry, STRONGOVA delivers premium wood solutions that exceed expectations through five core advantages:',
    heroEyebrow: 'STRONGOVA® Solid Wood Flooring — Global Craftsmanship',
    heroTitle: 'Uncompromising',
    heroTitleBold: 'Quality',
    heroIntro: 'In the solid wood flooring industry, STRONGOVA® delivers premium wood artistry solutions that exceed expectations, backed by five core advantages:',
    heroImage: `${assetBase}/advantage-hero.jpg`,
    heroPattern: `${assetBase}/advantage-pattern.png`,
    sectionPretitle: 'STRONGOVA® Solid Wood Flooring',
    sectionTitle: 'Global Craftsmanship, Uncompromising Quality',
    sectionIntro: 'In the solid wood flooring industry, STRONGOVA® delivers premium wood solutions that exceed expectations through five core advantages:',
    items: [
      {
        title: 'Efficient Delivery, Global Supply',
        body: 'Leveraging dual production bases in China & Serbia for coordinated global capacity, we ensure rapid 45-day standard delivery, with emergency orders expedited to just 7 days—maximizing project efficiency worldwide.'
      },
      {
        title: 'End-to-End Quality Control',
        body: '"We\'d rather increase QC costs by 30% than let one defective board leave our factory" — STRONGOVA® Quality Director'
      },
      {
        title: 'Rigorous Standards, Built to Last',
        body: 'Only FSC-certified premium timber is selected, guaranteeing exceptional stability even in extreme conditions. EU CE-certified for internationally recognized quality.'
      },
      {
        title: 'Expert Team, Full-Cycle Support',
        body: 'Backed by engineers and artisans with 20+ years of expertise, we provide professional guidance from material selection to installation, ensuring every plank meets high-end project standards.'
      },
      {
        title: 'Flexible Customization, Tailored Solutions',
        body: 'With extensive veneer reserves, we offer complete customization in dimensions, finishes, and textures—specializing in underfloor heating, ultra-wear-resistant, and other technical solutions for luxury homes, hotels, and commercial spaces.'
      }
    ],
    outro: 'Choosing STRONGOVA® means selecting the perfect synergy of reliability, efficiency, and masterful craftsmanship—far beyond just flooring.',
    videoTitle: 'Why STRONGOVA is the right Choice',
    videoPoster: `${assetBase}/advantage-video-poster.jpg`,
    video: ''
  },
  interests: {
    eyebrow: 'The Strongova Product World',
    title: 'I am interested in...',
    items: [
      { title: 'Natural wood floors', image: `${assetBase}/interest-natural.png`, href: '/products' },
      { title: 'Strength', image: `${assetBase}/interest-strength.png`, href: '/strength' },
      { title: 'Knowledge', image: `${assetBase}/interest-cases.png`, href: '/knowledge' },
      { title: 'Sales Partner', image: `${assetBase}/interest-sales.png`, href: '/contact?tab=partner' },
      { title: 'Manufactory', image: `${assetBase}/interest-factory.jpg`, href: '/contact?tab=factory' }
    ]
  },
  factory: {
    title: 'Our factory',
    image: `${assetBase}/factory-map.png`,
    locations: [
      {
        // title: 'China Dalian factory address',
        country: 'China',
        address: 'NO.59 HAIXiang Road, Daweijia Street,Jinzhou District,Dalian City.',
        phone: '+86 15668650333',
        whatsapp: '+86 15668650333',
        email: 'STRONGOVA@strongova.com'
      }
    ]
  },
  references: {
    eyebrow: 'In action',
    title: 'Reference examples',
    items: [
      { title: 'Germany case', image: `${assetBase}/ref-germany-1.jpg` },
      { title: 'Germany case', image: `${assetBase}/ref-germany-2.jpg` },
      { title: 'China case', image: `${assetBase}/ref-china.jpg` },
      { title: 'Korea case', image: `${assetBase}/ref-korea.jpg` },
      { title: 'USA case', image: `${assetBase}/ref-usa.jpg` },
      { title: 'Japan case', image: `${assetBase}/ref-japan.jpg` }
    ]
  },
  certifications: {
    eyebrow: 'OUR CURRENT',
    title: 'Overview of Wood Flooring Certifications',
    items: [
      { title: 'FSC', image: `${assetBase}/cert-fsc.png` },
      { title: 'CFCC', image: `${assetBase}/cert-cfcc.png` },
      { title: 'PEPC', image: `${assetBase}/cert-pepc.png` },
      { title: 'ANAS', image: `${assetBase}/cert-anas.png` },
      { title: 'UKCA', image: `${assetBase}/cert-ukca.png` },
      { title: 'CE', image: `${assetBase}/cert-ce.png` }
    ]
  },
  contact: {
    image: `${assetBase}/contact.jpg`,
    ceoImage: `${assetBase}/contact-letter.jpg`,
    ceoName: 'SHIRLEY, CEO',
    ceoEmail: 'STRONGOVA@strongova.com',
    countries: [
      'Austria', 'Germany', 'Italy', 'Switzerland', 'Egypt', 'Albania', 'Argentina',
      'Australia', 'Belgium', 'Bulgaria', 'China', 'Denmark', 'Estonia', 'Finland',
      'France', 'Georgia', 'Gibraltar', 'Greece', 'Guadeloupe', 'Hong Kong SAR China',
      'India', 'Ireland', 'Iceland', 'Israel', 'Japan', 'Canada', 'Kazakhstan', 'Qatar',
      'Croatia', 'Latvia', 'Lebanon', 'Lithuania', 'Luxembourg', 'Malta', 'Marshall Islands',
      'Mauritius', 'Mexico', 'Monaco', 'Netherlands', 'Norway', 'Poland', 'Portugal',
      'Rwanda', 'Romania', 'Russia', 'Sweden', 'Serbia', 'Singapore', 'Slovakia',
      'Slovenia', 'Spain', 'South Korea', 'Taiwan', 'Czechia', 'Turkiye', 'Ukraine',
      'Hungary', 'United States', 'United Kingdom', 'Cyprus', 'Other country'
    ],
    letter: [
      'Dear Friend,',
      'Thank you for choosing STRONGOVA and joining us in exploring the beautiful connection between nature and living.',
      'As the founder, I’ve always believed: The warmth of a home begins with every step upon something real. STRONGOVA selects only FSC-certified premium wood from around the world, crafting each piece with meticulous care to bring the forest’s gift into your space—not just as flooring, but as a fragment of nature in your daily life.',
      'When sunlight spills across your STRONGOVA floors, the wood’s natural grain breathes and evolves with the seasons. May this living warmth accompany your barefoot mornings, your children’s playful footsteps, or your pet’s lazy afternoon naps.',
      'We hope STRONGOVA becomes your way of expressing a life well lived.'
    ],
    customerTypes: [
      { label: 'End customer/client', value: 'customer' },
      { label: 'Architect/designer', value: 'architect' },
      { label: 'Installers/partners', value: 'partner' },
      { label: 'mafi flooring owners', value: 'mafi' }
    ],
    requestTypes: [
      { label: 'General inquiry', value: 'default' },
      { label: 'Information material', value: 'handout' },
      { label: 'Partner close to me', value: 'partner' },
      { label: 'Pellets', value: 'pellets' }
    ],
    handoutTypes: [
      { label: 'mafi portfolio', value: 'portfolio' },
      { label: 'mafi care instructions', value: 'care' },
      { label: 'mafi installation instructions', value: 'installation' },
      { label: 'Why mafi?', value: 'why-mafi' },
      { label: 'request.handout.inspirationen', value: 'inspirationen' },
      { label: 'request.handout.mafi360', value: 'mafi360' },
      { label: 'request.handout.terrassen', value: 'terrassen' },
      { label: 'request.handout.boiserie', value: 'boiserie' }
    ],
    salutations: [
      { label: 'Mr.', value: 'mr' },
      { label: 'Ms.', value: 'ms' },
      { label: 'Family', value: 'family' }
    ],
    partnerImage: `${assetBase}/contact-partner.jpg`,
    partnerEyebrow: 'WELCOME TO JOIN US!',
    partnerTitle: 'Become A Distribution Partner',
    partnerCopy: [
      'We have been actively seeking suitable distribution partners and warmly welcome you to join our global sales network. STRONGOVA offers natural solid wood flooring, manufactured and shipped from our factories in China and Serbia. With stable and ample supply, diverse product range, premium quality, and support for customized solutions, our products are highly favored by consumers worldwide.',
      'We provide comprehensive product packages and investment portfolios. If you are a local flooring wholesaler and interested in our products, please feel free to contact us.',
      'We value communication with every client and always prioritize the needs of end-users. Partnering with us will undoubtedly be an excellent choice for your business.'
    ],
    factoryMapImage: `${assetBase}/contact-factory-map.png`,
    projectsEyebrow: 'Selected',
    projectsTitle: 'Projects',
    projectsGalleryRow1: [
      casesAsset('case-01.jpg'),
      casesAsset('case-02.jpg'),
      casesAsset('case-03.jpg'),
      casesAsset('case-04.jpg'),
      casesAsset('case-05.jpg')
    ],
    projectsGalleryRow2: [
      casesAsset('case-06.jpg'),
      casesAsset('case-07.jpg'),
      casesAsset('case-08.jpg'),
      casesAsset('case-09.jpg'),
      casesAsset('case-10.jpg')
    ]
  },
  productsPage: {
    eyebrow: 'High-quality natural wood solutions',
    title: 'Our Products',
    intro: 'In addition to our wooden floors, we offer a variety of high-quality natural wood solutions for holistic room concepts.',
    contentImage: `${assetBase}/products_1_bg.png`,
    primaryGroups: [
      {
        title: 'NATURAL WOOD FLOORS',
        href: '/products',
        children: [
          { title: 'Plank', href: '/products-list/plank', originalHref: '/products_list/Plank.html', slug: 'plank' },
          { title: 'Herringbone Plank 90°', href: '/products-list/herringbone-plank-90deg', originalHref: '/products_list/Herringbone Plank 90deg.html', slug: 'herringbone-plank-90deg' },
          { title: 'Chevron Plank 45°', href: '/products-list/chevron-plank-45deg', originalHref: '/products_list/Chevron Plank 45deg.html', slug: 'chevron-plank-45deg' },
          { title: 'Parquet', href: '/products-list/parquet', originalHref: '/products_list/Parquet.html', slug: 'parquet' },
          { title: 'Oversized Plank', href: '/products-list/oversized-plank', originalHref: '/products_list/Oversized Plank.html', slug: 'oversized-plank' }
        ]
      },
      // {
      //   title: 'COLOURS',
      //   href: '/colours',
      //   children: [
      //     { title: 'Light Wood Floors', href: '/products-list/light-wood-floors', originalHref: '/products_list/Light Wood Floors.html', slug: 'light-wood-floors' },
      //     { title: 'Dark Wood Floors', href: '/products-list/dark-wood-floors', originalHref: '/products_list/Dark Wood Floors.html', slug: 'dark-wood-floors' }
      //   ]
      // }
    ],
    categories: [
      {
        title: 'Plank',
        image: `${assetBase}/product-plank.jpg`,
        summary: 'Clean long-board rhythm for residential and hospitality spaces.',
        href: '/products-list/plank',
        slug: 'plank',
        format: 'Linear plank',
        size: '120-220mm width',
        structure: '3-layer / multi-layer'
      },
      {
        title: 'Herringbone Plank 90°',
        image: `${assetBase}/product-herringbone.jpg`,
        summary: 'A classic pattern with more structure and visual movement.',
        href: '/products-list/herringbone-plank-90deg',
        slug: 'herringbone-plank-90deg',
        format: '90° herringbone',
        size: '70-120mm width',
        structure: 'Engineered pattern plank'
      },
      {
        title: 'Chevron Plank 45°',
        image: `${assetBase}/product-chevron.jpg`,
        summary: 'Directional geometry for editorial and luxury environments.',
        href: '/products-list/chevron-plank-45deg',
        slug: 'chevron-plank-45deg',
        format: '45° chevron',
        size: '90-140mm width',
        structure: 'Precision angle plank'
      },
      {
        title: 'Parquet',
        image: `${assetBase}/product-parquet.jpg`,
        summary: 'Decorative repeat patterns that bring heritage into modern interiors.',
        href: '/products-list/parquet',
        slug: 'parquet',
        format: 'Modular parquet',
        size: 'Custom modules',
        structure: 'Decorative engineered panel'
      },
      {
        title: 'Oversized Plank',
        image: `${assetBase}/product-oversized.jpg`,
        summary: 'Large-format boards designed to read calm, continuous, and architectural.',
        href: '/products-list/oversized-plank',
        slug: 'oversized-plank',
        format: 'Wide long plank',
        size: '220-300mm width',
        structure: 'Stability-focused engineered'
      }
    ],
    structures: [
      { title: 'Three-layer structure', image: `${assetBase}/product-structure-three.png`, body: 'Three-layer structure' },
      { title: 'Multi-layer structure', image: `${assetBase}/product-structure-multi.png`, body: 'Multi-layer structure' }
    ],
    surfaces: [
      { title: 'Disstressed', image: `${assetBase}/quality-feeling.jpg` },
      { title: 'Hand Scraped', image: `${assetBase}/news-1.jpg` },
      { title: 'Sawmarked', image: `${assetBase}/ref-germany-1.jpg` },
      { title: 'Wire Brushed', image: `${assetBase}/product-herringbone.jpg` },
      { title: 'Deep Brushed', image: `${assetBase}/colour-dark.jpg` },
      { title: 'Wave', image: `${assetBase}/quality-origin.jpg` },
      { title: 'Broken Edge', image: `${assetBase}/product-parquet.jpg` },
      { title: 'Hand Scraped', image: `${assetBase}/product-plank.jpg` },
      { title: 'Hand Scraped', image: `${assetBase}/product-oversized.jpg` }
    ],
    notes: [
      'Underfloor-heating compatible systems are available for climate-sensitive projects.',
      'Surface finish, gloss, wire brushing, smoking, and sizing can all be tuned to project intent.',
      'Factory support includes sampling, finish matching, and export coordination.'
    ],
    selectionGuide: [
      { title: 'Choose by layout', body: 'Start with the visual rhythm: calm linear planks, patterned herringbone, sharper chevron, decorative parquet, or oversized architectural boards.' },
      { title: 'Choose by structure', body: 'Three-layer and multi-layer constructions answer different stability, installation, and budget requirements.' },
      { title: 'Choose by finish', body: 'Brushing, smoking, hand scraping, natural oil, and UV lacquer change both the look and maintenance behavior.' }
    ],
    technicalBands: [
      { label: 'Top layer', value: '2-6mm' },
      { label: 'Moisture control', value: 'Factory calibrated' },
      { label: 'Heating', value: 'Compatible options' },
      { label: 'Finish', value: 'Oil / lacquer / custom' }
    ]
  },
  productLists: {
    plank: {
      title: 'Plank',
      group: 'NATURAL WOOD FLOORS',
      heroImage: `${assetBase}/product-plank.jpg`,
      intro: 'Linear plank products with calm long-board rhythm.',
      products: ['am-01', 'am-02', 'am-03', 'am-04']
    },
    'herringbone-plank-90deg': {
      title: 'Herringbone Plank 90°',
      group: 'NATURAL WOOD FLOORS',
      heroImage: `${assetBase}/product-herringbone.jpg`,
      intro: 'Classic 90 degree herringbone products for patterned interiors.',
      products: ['am-05', 'am-06', 'am-07']
    },
    'chevron-plank-45deg': {
      title: 'Chevron Plank 45°',
      group: 'NATURAL WOOD FLOORS',
      heroImage: `${assetBase}/product-chevron.jpg`,
      intro: 'Directional 45 degree chevron products with a sharper visual rhythm.',
      products: ['am-08', 'am-09']
    },
    parquet: {
      title: 'Parquet',
      group: 'NATURAL WOOD FLOORS',
      heroImage: `${assetBase}/product-parquet.jpg`,
      intro: 'Decorative parquet products for classic and signature rooms.',
      products: ['am-10', 'am-11']
    },
    'oversized-plank': {
      title: 'Oversized Plank',
      group: 'NATURAL WOOD FLOORS',
      heroImage: `${assetBase}/product-oversized.jpg`,
      intro: 'Wide and long plank products for calm architectural spaces.',
      products: ['am-12', 'am-13']
    },
    'light-wood-floors': {
      title: 'Light Wood Floors',
      group: 'COLOURS',
      heroImage: `${assetBase}/colour-light.jpg`,
      intro: 'Light toned floors for bright, natural and open interiors.',
      products: ['am-01', 'am-03', 'am-08', 'am-12']
    },
    'dark-wood-floors': {
      title: 'Dark Wood Floors',
      group: 'COLOURS',
      heroImage: `${assetBase}/colour-dark.jpg`,
      intro: 'Darker wood floors for formal, warm and expressive rooms.',
      products: ['am-04', 'am-06', 'am-10', 'am-13']
    }
  },
  productItems: {
    'am-01': {
      code: 'AM-01',
      title: 'AM-01',
      category: 'Plank',
      colour: 'Light Wood Floors',
      image: `${assetBase}/product-plank.jpg`,
      summary: 'Natural oak plank with a calm light tone and clean linear read.',
      specs: [
        { label: 'Species', value: 'European Oak' },
        { label: 'Structure', value: 'Three-layer engineered' },
        { label: 'Surface', value: 'Brushed / natural oil' },
        { label: 'Size', value: '1900 x 190 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Natural oil' },
        { label: 'Construction', value: 'Three-layer engineered' },
        { label: 'Application', value: 'Residential / hotel' },
        { label: 'Grade', value: 'AB' }
      ]
    },
    'am-02': {
      code: 'AM-02',
      title: 'AM-02',
      category: 'Plank',
      colour: 'Light Wood Floors',
      image: `${assetBase}/colour-light.jpg`,
      summary: 'Soft light plank for Nordic residential and hospitality interiors.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Multi-layer engineered' },
        { label: 'Surface', value: 'Matte oil' },
        { label: 'Size', value: '1900 x 190 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Matte oil' },
        { label: 'Construction', value: 'Multi-layer engineered' },
        { label: 'Application', value: 'Residential' },
        { label: 'Grade', value: 'ABC' }
      ]
    },
    'am-03': {
      code: 'AM-03',
      title: 'AM-03',
      category: 'Plank',
      colour: 'Light Wood Floors',
      image: `${assetBase}/product-structure-three.png`,
      summary: 'Three-layer plank option with visible engineered structure.',
      specs: [
        { label: 'Species', value: 'Oak veneer' },
        { label: 'Structure', value: 'Three-layer' },
        { label: 'Surface', value: 'Low sheen lacquer' },
        { label: 'Size', value: '2200 x 220 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Low sheen lacquer' },
        { label: 'Construction', value: 'Three-layer engineered' },
        { label: 'Application', value: 'Villa / apartment' },
        { label: 'Grade', value: 'AB' }
      ]
    },
    'am-04': {
      code: 'AM-04',
      title: 'AM-04',
      category: 'Plank',
      colour: 'Dark Wood Floors',
      image: `${assetBase}/colour-dark.jpg`,
      summary: 'Darker plank expression for formal and warm interiors.',
      specs: [
        { label: 'Species', value: 'Smoked Oak' },
        { label: 'Structure', value: 'Multi-layer' },
        { label: 'Surface', value: 'Brushed / oiled' },
        { label: 'Size', value: '1900 x 190 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Brushed oil' },
        { label: 'Construction', value: 'Multi-layer engineered' },
        { label: 'Application', value: 'Formal residential' },
        { label: 'Grade', value: 'AB' }
      ]
    },
    'am-05': {
      code: 'AM-05',
      title: 'AM-05',
      category: 'Herringbone Plank 90°',
      colour: 'Light Wood Floors',
      image: `${assetBase}/product-herringbone.jpg`,
      summary: 'Classic 90 degree herringbone in a natural oak tone.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Three-layer' },
        { label: 'Surface', value: 'UV lacquer' },
        { label: 'Size', value: '600 x 90 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'UV lacquer' },
        { label: 'Construction', value: 'Three-layer engineered' },
        { label: 'Application', value: 'Feature room' },
        { label: 'Pattern', value: '90° herringbone' }
      ]
    },
    'am-06': {
      code: 'AM-06',
      title: 'AM-06',
      category: 'Herringbone Plank 90°',
      colour: 'Dark Wood Floors',
      image: `${assetBase}/ref-germany-1.jpg`,
      summary: 'Smoked herringbone direction for richer residential spaces.',
      specs: [
        { label: 'Species', value: 'Smoked Oak' },
        { label: 'Structure', value: 'Engineered' },
        { label: 'Surface', value: 'Saw mark / UV lacquer' },
        { label: 'Size', value: '600 x 90 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Saw mark / UV lacquer' },
        { label: 'Construction', value: 'Engineered hardwood' },
        { label: 'Application', value: 'Premium residence' },
        { label: 'Pattern', value: '90° herringbone' }
      ]
    },
    'am-07': {
      code: 'AM-07',
      title: 'AM-07',
      category: 'Herringbone Plank 90°',
      colour: 'Light Wood Floors',
      image: `${assetBase}/ref-korea.jpg`,
      summary: 'Soft brushed herringbone with relaxed natural character.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Three-layer' },
        { label: 'Surface', value: 'Brushed lacquer' },
        { label: 'Size', value: '600 x 90 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Brushed lacquer' },
        { label: 'Construction', value: 'Three-layer engineered' },
        { label: 'Application', value: 'Residential / hospitality' },
        { label: 'Pattern', value: '90° herringbone' }
      ]
    },
    'am-08': {
      code: 'AM-08',
      title: 'AM-08',
      category: 'Chevron Plank 45°',
      colour: 'Light Wood Floors',
      image: `${assetBase}/product-chevron.jpg`,
      summary: 'Fresh chevron product with a sharp directional point.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Engineered' },
        { label: 'Surface', value: 'Brushed UV lacquer' },
        { label: 'Size', value: '720 x 120 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Brushed UV lacquer' },
        { label: 'Construction', value: 'Engineered hardwood' },
        { label: 'Application', value: 'Design-led interior' },
        { label: 'Pattern', value: '45° chevron' }
      ]
    },
    'am-09': {
      code: 'AM-09',
      title: 'AM-09',
      category: 'Chevron Plank 45°',
      colour: 'Light Wood Floors',
      image: `${assetBase}/ref-japan.jpg`,
      summary: 'Elegant chevron floor for composed design-led interiors.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Three-layer' },
        { label: 'Surface', value: 'Matte lacquer' },
        { label: 'Size', value: '720 x 120 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Matte lacquer' },
        { label: 'Construction', value: 'Three-layer engineered' },
        { label: 'Application', value: 'Apartment / showroom' },
        { label: 'Pattern', value: '45° chevron' }
      ]
    },
    'am-10': {
      code: 'AM-10',
      title: 'AM-10',
      category: 'Parquet',
      colour: 'Dark Wood Floors',
      image: `${assetBase}/product-parquet.jpg`,
      summary: 'Decorative parquet product with a richer classic tone.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Engineered panel' },
        { label: 'Surface', value: 'Smoked / oiled' },
        { label: 'Size', value: 'Custom module' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Smoked oil' },
        { label: 'Construction', value: 'Engineered parquet panel' },
        { label: 'Application', value: 'Reception / lounge' },
        { label: 'Pattern', value: 'Parquet' }
      ]
    },
    'am-11': {
      code: 'AM-11',
      title: 'AM-11',
      category: 'Parquet',
      colour: 'Light Wood Floors',
      image: `${assetBase}/quality-hero.jpg`,
      summary: 'Light parquet direction for heritage-inspired modern rooms.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Decorative engineered' },
        { label: 'Surface', value: 'Natural oil' },
        { label: 'Size', value: 'Custom module' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Natural oil' },
        { label: 'Construction', value: 'Decorative engineered panel' },
        { label: 'Application', value: 'Study / classic room' },
        { label: 'Pattern', value: 'Parquet' }
      ]
    },
    'am-12': {
      code: 'AM-12',
      title: 'AM-12',
      category: 'Oversized Plank',
      colour: 'Light Wood Floors',
      image: `${assetBase}/product-oversized.jpg`,
      summary: 'Oversized light plank for open luxury interiors.',
      specs: [
        { label: 'Species', value: 'Oak' },
        { label: 'Structure', value: 'Stability-focused engineered' },
        { label: 'Surface', value: 'Low sheen oil' },
        { label: 'Size', value: '2400 x 260 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Low sheen oil' },
        { label: 'Construction', value: 'Stability-focused engineered' },
        { label: 'Application', value: 'Open-plan villa' },
        { label: 'Format', value: 'Oversized plank' }
      ]
    },
    'am-13': {
      code: 'AM-13',
      title: 'AM-13',
      category: 'Oversized Plank',
      colour: 'Dark Wood Floors',
      image: `${assetBase}/ref-usa.jpg`,
      summary: 'Wide plank direction with deeper formal character.',
      specs: [
        { label: 'Species', value: 'Smoked Oak' },
        { label: 'Structure', value: 'Engineered' },
        { label: 'Surface', value: 'Brushed oil' },
        { label: 'Size', value: '2400 x 260 x 15/4mm' },
        { label: 'Thickness', value: '15/4mm' },
        { label: 'Finish', value: 'Brushed oil' },
        { label: 'Construction', value: 'Engineered wide plank' },
        { label: 'Application', value: 'Luxury suite' },
        { label: 'Format', value: 'Oversized plank' }
      ]
    }
  },
  productDetails: {
    plank: {
      title: 'Plank',
      eyebrow: 'Natural wood floors',
      heroImage: `${assetBase}/product-plank.jpg`,
      intro: 'The plank range is the calmest expression in the collection: long linear boards, fewer visual interruptions, and an easy fit for residential, hospitality, and commercial interiors that need warmth without ornament.',
      highlights: [
        'Best when the room wants visual length and a clean architectural rhythm.',
        'Works across oak-led modern interiors, hospitality fit-outs, and premium residential projects.',
        'A strong base format for surface treatments such as brushing, smoking, or oil-driven tonal shifts.'
      ],
      specs: [
        { label: 'Format direction', value: 'Long-board plank layout' },
        { label: 'Best fit', value: 'Residential, hotel, and retail interiors' },
        { label: 'Available structure', value: 'Three-layer and multi-layer options' },
        { label: 'Customization', value: 'Width, length, brushing, color, and finish' },
        { label: 'Typical width', value: '120-220mm' },
        { label: 'Typical length', value: '600-2200mm' },
        { label: 'Surface options', value: 'Brushed, smoked, natural oil, UV lacquer' },
        { label: 'Heating system', value: 'Available with compatible structure' }
      ],
      applications: ['Private residences', 'Boutique hospitality', 'Quiet luxury commercial spaces'],
      surfaces: ['Natural oil for a matte and tactile read', 'UV lacquer for sealed project consistency', 'Wire brushing for visible grain texture', 'Smoking for warmer oak variation'],
      construction: [
        { title: 'Stable core', body: 'Engineered construction helps control movement while keeping the visible wood surface generous.' },
        { title: 'Clean profile', body: 'A linear board format supports efficient installation and a calm architectural rhythm.' },
        { title: 'Project tuning', body: 'Width, length, bevel, sheen, color, and packing logic can be adjusted for the target market.' }
      ],
      gallery: [`${assetBase}/product-plank.jpg`, `${assetBase}/product-structure-three.png`, `${assetBase}/product-structure-multi.png`]
    },
    'herringbone-90': {
      title: 'Herringbone Plank 90°',
      eyebrow: 'Natural wood floors',
      heroImage: `${assetBase}/product-herringbone.jpg`,
      intro: 'Herringbone gives the collection more movement and tradition. It carries a recognizable classic language, but in the right finish it still lands cleanly in contemporary interiors.',
      highlights: [
        'Adds pattern energy without becoming overly decorative.',
        'Useful for entrance halls, formal living areas, and hospitality projects that need more identity.',
        'Pairs especially well with smoked, brushed, or darker oak directions.'
      ],
      specs: [
        { label: 'Pattern logic', value: 'Perpendicular 90° herringbone' },
        { label: 'Best fit', value: 'Feature rooms and premium residential zones' },
        { label: 'Available structure', value: 'Engineered plank construction' },
        { label: 'Customization', value: 'Board size, tone, bevel, and sheen' },
        { label: 'Typical width', value: '70-120mm' },
        { label: 'Typical length', value: '420-900mm' },
        { label: 'Surface options', value: 'Brushed, smoked, saw mark, UV lacquer' },
        { label: 'Installation cue', value: 'Pattern planning and direction control' }
      ],
      applications: ['Formal residences', 'Heritage-inspired remodels', 'High-touch hospitality spaces'],
      surfaces: ['Smoked oak for a richer classic tone', 'Saw-mark texture for more visible craft', 'Matte lacquer for hospitality durability', 'Soft brushing to keep the pattern from feeling flat'],
      construction: [
        { title: 'Pattern accuracy', body: 'Each piece needs consistent profiling so the 90-degree rhythm remains clean across the room.' },
        { title: 'Balanced expression', body: 'Herringbone adds identity while still staying familiar to premium residential clients.' },
        { title: 'Finish matching', body: 'Batch control matters because patterned floors make tonal shifts more visible.' }
      ],
      gallery: [`${assetBase}/product-herringbone.jpg`, `${assetBase}/quality-feeling.jpg`, `${assetBase}/colour-dark.jpg`]
    },
    'chevron-45': {
      title: 'Chevron Plank 45°',
      eyebrow: 'Natural wood floors',
      heroImage: `${assetBase}/product-chevron.jpg`,
      intro: 'Chevron is the sharper, more directional cousin in the patterned range. The geometry feels deliberate and editorial, which makes it strong in projects that want a more composed visual signature.',
      highlights: [
        'Creates a clear directional read through the room.',
        'Feels especially effective in luxury retail, branded spaces, and statement residences.',
        'Offers a more graphic look than herringbone while staying unmistakably wood.'
      ],
      specs: [
        { label: 'Pattern logic', value: '45-degree chevron point' },
        { label: 'Best fit', value: 'Statement rooms and design-led commercial spaces' },
        { label: 'Available structure', value: 'Engineered plank construction' },
        { label: 'Customization', value: 'Angle precision, board proportion, tone, and texture' },
        { label: 'Typical width', value: '90-140mm' },
        { label: 'Typical length', value: '540-1000mm' },
        { label: 'Surface options', value: 'Natural, brushed, smoked, oiled' },
        { label: 'Installation cue', value: 'Directional point alignment' }
      ],
      applications: ['Show homes', 'Luxury apartments', 'Editorial retail settings'],
      surfaces: ['Natural oak for a lighter architectural direction', 'Smoked finish for stronger visual depth', 'Brushed texture to catch light along the point', 'Low sheen oil to keep the geometry soft'],
      construction: [
        { title: 'Precise angle work', body: 'Chevron depends on accurate cutting and profiling, because small errors become visible at the central point.' },
        { title: 'Directional movement', body: 'The layout naturally draws the eye through the room, making it strong for corridors and statement spaces.' },
        { title: 'Design-led specification', body: 'Board proportion, point width, and tone should be selected together rather than independently.' }
      ],
      gallery: [`${assetBase}/product-chevron.jpg`, `${assetBase}/quality-origin.jpg`, `${assetBase}/colour-light.jpg`]
    },
    parquet: {
      title: 'Parquet',
      eyebrow: 'Natural wood floors',
      heroImage: `${assetBase}/product-parquet.jpg`,
      intro: 'Parquet gives the system its most decorative vocabulary. It is useful when a project wants pattern memory, craftsmanship cues, and a stronger sense of historical richness.',
      highlights: [
        'Brings heritage references into modern spaces without requiring antique detailing everywhere else.',
        'Best for rooms where the floor is expected to carry part of the identity.',
        'Can be tuned with lighter oils or calmer textures to keep the result contemporary.'
      ],
      specs: [
        { label: 'Pattern logic', value: 'Decorative modular parquet compositions' },
        { label: 'Best fit', value: 'Signature rooms and classic-luxury interiors' },
        { label: 'Available structure', value: 'Engineered decorative panel systems' },
        { label: 'Customization', value: 'Pattern composition, border logic, species, and finish' },
        { label: 'Module size', value: 'Project-specific' },
        { label: 'Layout support', value: 'Border and field planning' },
        { label: 'Surface options', value: 'Oil, lacquer, brushed, smoked' },
        { label: 'Installation cue', value: 'Modular repeat control' }
      ],
      applications: ['Private studies', 'Reception lounges', 'Restoration-minded luxury interiors'],
      surfaces: ['Light oil to keep decorative pattern contemporary', 'Smoked tone for classic richness', 'Brushed surface for more grain relief', 'Border contrast for heritage-inspired spaces'],
      construction: [
        { title: 'Modular planning', body: 'Parquet works best when the room size, border logic, and repeat module are planned together.' },
        { title: 'Decorative hierarchy', body: 'It can carry the identity of a room, so surrounding materials should stay disciplined.' },
        { title: 'Custom composition', body: 'Species mix, panel size, border strategy, and sheen can be specified around the project brief.' }
      ],
      gallery: [`${assetBase}/product-parquet.jpg`, `${assetBase}/ref-germany-1.jpg`, `${assetBase}/quality-hero.jpg`]
    },
    'oversized-plank': {
      title: 'Oversized Plank',
      eyebrow: 'Natural wood floors',
      heroImage: `${assetBase}/product-oversized.jpg`,
      intro: 'Oversized plank is the most architectural member of the range. Wider and longer boards reduce visual noise and help large rooms feel calmer, more continuous, and more expensive.',
      highlights: [
        'Designed for open plans, large villas, penthouses, and hospitality suites.',
        'Lets wood grain read with more continuity across the floor plate.',
        'Strong option when the space itself is generous and standard board rhythm feels too busy.'
      ],
      specs: [
        { label: 'Format direction', value: 'Large-format long and wide plank' },
        { label: 'Best fit', value: 'Open-plan luxury residential and hospitality projects' },
        { label: 'Available structure', value: 'Stability-focused engineered build' },
        { label: 'Customization', value: 'Oversized width, extended length, tone, and texture' },
        { label: 'Typical width', value: '220-300mm' },
        { label: 'Typical length', value: '1800-2400mm' },
        { label: 'Surface options', value: 'Natural oil, brushed, low sheen lacquer' },
        { label: 'Installation cue', value: 'Subfloor flatness and stability' }
      ],
      applications: ['Villas and penthouses', 'Presidential suites', 'Large-format commercial interiors'],
      surfaces: ['Low-sheen oil for a calm luxury read', 'Light brushing to keep large boards tactile', 'Natural oak for open-plan brightness', 'Deeper tones for formal suites and lounges'],
      construction: [
        { title: 'Large-board stability', body: 'Wider boards need more careful structure, moisture control, and installation preparation.' },
        { title: 'Continuous grain', body: 'The main value is visual calm: fewer joints and a more architectural surface.' },
        { title: 'Premium coordination', body: 'Sampling and site condition checks matter more because each board has more visual presence.' }
      ],
      gallery: [`${assetBase}/product-oversized.jpg`, `${assetBase}/ref-usa.jpg`, `${assetBase}/product-structure-three.png`]
    }
  },
  customizePage: {
    detailTitle: 'Personalized Customization',
    verificationBg: customizeAsset('static/images/bg-pattern.0Dqe6L_V.jpg'),
    detailGallery: [
      customizeAsset('uploads/images/20250617/21f7f94e0a918c4919efea8bcde23a4f.jpg'),
      customizeAsset('uploads/images/20250617/cd2beab5697733243c3ec52e276a1918.jpg'),
      customizeAsset('uploads/images/20250617/48667a36879650feaedcbb5e7b3f94ad.jpg'),
      customizeAsset('uploads/images/20250617/c68d172afd22a55a59127bbeae739e5e.jpg'),
      customizeAsset('uploads/images/20250617/6f5d50706016e69cc258394cf27d0c41.jpg'),
      customizeAsset('uploads/images/20250617/e6dca1c503bd08f2faf2c1be4cdfe33b.jpg'),
      customizeAsset('uploads/images/20250617/b9c3ea97c683617ac2780458a04f1671.jpg'),
      customizeAsset('uploads/images/20250617/47eb82a142b90f648f951ccd47db80fa.jpg'),
      customizeAsset('uploads/images/20250617/895accc8a48c3e630dd16bf74c2e58db.jpg'),
      customizeAsset('uploads/images/20250617/8aacec9f1aa73b20e71714ac219fd3d5.jpg')
    ],
    craftChips: ['Disstressed', 'handscraped', 'sawmarked', 'wire brushed', 'deep brushed', 'wave', 'broken edge'],
    craftOptions: [
      { chip: 'Disstressed', title: 'Disstressed', image: customizeAsset('uploads/images/20250605/02acc1cd340980aab33f177cf9a15d86.jpg') },
      { chip: 'handscraped', title: 'Hand Scraped', image: customizeAsset('uploads/images/20250605/b1a2a48d978cf67a46ae38b592e0d3dd.jpg') },
      { chip: 'sawmarked', title: 'Sawmarked', image: customizeAsset('uploads/images/20250605/12f3015e31c776d06596a78426f0f572.jpg') },
      { chip: 'wire brushed', title: 'Wire Brushed', image: customizeAsset('uploads/images/20250605/879d4b8853932826a6bea382d37c025f.jpg') },
      { chip: 'deep brushed', title: 'Deep Brushed', image: customizeAsset('uploads/images/20250605/4a65c1a18576be0d27fb40a3f7cc6e49.jpg') },
      { chip: 'wave', title: 'Wave', image: customizeAsset('uploads/images/20250605/90480e3ace86f511e6d5aef6174d2268.jpg') },
      { chip: 'broken edge', title: 'Broken Edge', image: customizeAsset('uploads/images/20250605/59b881a03fe5fa0b1bedefbb9b870fef.jpg') },
      { chip: 'handscraped', title: 'Hand  Scraped', image: customizeAsset('uploads/images/20250609/77525e5bd0c5d91d07c447e08de26f54.jpg') },
      { chip: 'handscraped', title: 'Hand  Scraped', image: customizeAsset('uploads/images/20250609/8c4327f58bfd187848f7bdafec494b11.jpg') }
    ],
    plankTypes: [
      { label: 'Plank', href: '/products-list/plank' },
      { label: 'Herringbone Plank 90°', href: '/products-list/herringbone-plank-90deg' },
      { label: 'Chevron Plank 45°', href: '/products-list/chevron-plank-45deg' },
      { label: 'Oversized Panel', href: '/products-list/oversized-plank' },
      { label: 'Parquet', href: '/products-list/parquet' }
    ],
    lengths: ['510', '600', '1900', '2200'],
    widths: ['90', '120', '190', '220', '260'],
    thicknesses: ['14', '15'],
    verificationPreTitle: 'All for LEED, BREAM or your personal project',
    verificationTitle: 'Third party verified',
    verificationLogos: [
      customizeAsset('uploads/images/20250606/3fc864d9c580e0ccc1e910ef8ac6764d.png'),
      customizeAsset('uploads/images/20250611/4af7aa232fbc2ccb0160e28e13672e49.png'),
      customizeAsset('uploads/images/20250611/beabe7417599079aa1864f984336a0cc.png'),
      customizeAsset('uploads/images/20250613/de6345c084e677c9faedd037a550910b.png'),
      customizeAsset('uploads/images/20250611/89b95ec051ebc55487ae58513ddae5db.png'),
      customizeAsset('uploads/images/20250611/632740d0e76547d3dd407c5c829fc49b.png')
    ],
    referencePreTitle: 'In action',
    referenceTitle: 'Reference examples',
    references: [
      { title: 'Germany case', subtitle: 'Solid wood three-layer flooring', image: customizeAsset('uploads/images/20250617/5c47d491c555de3943a2903fa8509b16.jpg') },
      { title: 'Germany case', subtitle: 'Herringbone 90° three-layer flooring', image: customizeAsset('uploads/images/20250617/d1828131bedb5319cc4f0fa99311504e.jpg') },
      { title: 'China case', subtitle: 'Herringbone 90° three-layer flooring', image: customizeAsset('uploads/images/20250617/80d0d0e16cf4e35d68877781ae9facbb.jpg') },
      { title: 'Germany case', subtitle: 'Herringbone 90° three-layer flooring', image: customizeAsset('uploads/images/20250617/d4c04356509c41c8542f2d1e113fbde6.jpg') },
      { title: 'Korea case', subtitle: 'Herringbone 90° three-layer flooring', image: customizeAsset('uploads/images/20250617/d2ca571c1538f5befde9540bf55009a2.jpg') },
      { title: 'USA case', subtitle: 'Herringbone 90° three-layer flooring', image: customizeAsset('uploads/images/20250617/5ed17ecfd8b6374f2215881a3cf463bb.jpg') },
      { title: 'Germany case', subtitle: 'Parquet multi-layer flooring', image: customizeAsset('uploads/images/20250617/508ac94e100bcdc655cad6df454ed0bf.jpg') },
      { title: 'Japan case', subtitle: 'Chevron 45° three-layer flooring', image: customizeAsset('uploads/images/20250617/cfbcd298b72aa834ed232e6eac4d9c7c.jpg') },
      { title: 'China case', subtitle: 'Chevron 45° three-layer flooring', image: customizeAsset('uploads/images/20250617/625b30e1927a2f5910516ae9c73a4156.jpg') },
      { title: 'Korea case', subtitle: 'Chevron 45° three-layer flooring', image: customizeAsset('uploads/images/20250617/aa1bbedbd97c92e07f9dc0065657cfc7.jpg') }
    ],
    adviceTitle: 'We are happy to advise you!',
    adviceImage: customizeAsset('static/images/customized_3_left.jpg'),
    steps: [
      { title: 'Select structure', body: 'Choose the base construction according to stability, budget, and installation requirements.' },
      { title: 'Define visual character', body: 'Lock color direction, grain feel, brushing depth, sheen, and edge treatment.' },
      { title: 'Solve technical constraints', body: 'Tune board size, locking, humidity tolerance, and underfloor heating compatibility.' },
      { title: 'Approve samples', body: 'Review physical samples before production so procurement and design stay aligned.' }
    ],
    options: ['Species and veneer reserve', 'Board dimension and pattern', 'Surface texture and finish', 'Packaging and market labeling'],
    gallery: [
      `${assetBase}/product-plank.jpg`,
      `${assetBase}/product-herringbone.jpg`,
      `${assetBase}/product-chevron.jpg`,
      `${assetBase}/product-parquet.jpg`
    ],
    verification: [
      { title: 'FSC controlled material', body: 'Wood sourcing can be aligned with responsible forestry requirements.' },
      { title: 'CE-ready production logic', body: 'Factory documentation and inspection flow support export-focused projects.' },
      { title: 'Sample-first approval', body: 'Physical samples keep color, texture, and finish decisions grounded before production.' }
    ],
    surfaces: [
      { title: 'Brushed', body: 'Raises the grain and gives the floor a more tactile natural read.' },
      { title: 'Smoked', body: 'Deepens oak tone and adds richer variation for premium interiors.' },
      { title: 'Hand scraped', body: 'Creates a crafted surface with visible irregularity and warmth.' },
      { title: 'Natural oil', body: 'Keeps the surface open, matte, and closer to the feel of real wood.' }
    ],
    sizes: [
      { label: 'Plank width', value: '120-300mm' },
      { label: 'Plank length', value: '600-2400mm' },
      { label: 'Top layer', value: '2-6mm options' },
      { label: 'Structure', value: '3-layer or multi-layer' }
    ],
    matrix: [
      { label: 'Product format', value: 'Plank, herringbone, chevron, parquet, oversized plank' },
      { label: 'Colour direction', value: 'Light, natural, smoked, dark, project-matched tone' },
      { label: 'Surface craft', value: 'Brushed, smoked, hand scraped, saw mark, natural oil, UV lacquer' },
      { label: 'Project package', value: 'Sampling, dimensions, packing, labeling, export documentation' }
    ],
    handoff: [
      { title: 'Start with product', body: 'Pick the format that matches the room rhythm and installation logic.' },
      { title: 'Lock colour direction', body: 'Choose light, natural, smoked, or dark tone under real lighting conditions.' },
      { title: 'Approve physical sample', body: 'Confirm actual grain, texture, sheen, and tone before production.' }
    ],
    cta: 'For custom programs, the cleanest next move is to send target dimensions, finish references, and market requirements through the contact page.'
  },
  knowledgePage: {
    eyebrow: 'High-quality natural wood solutions',
    title: 'News about STRONGOVA',
    heroImage: `${assetBase}/news-1.jpg`,
    sectionTitle: 'NEWS',
    pageSize: 4,
    articles: [
      {
        title: 'Elevate Your Space with Natural Oak Craftsmanship',
        slug: 'elevate-your-space-with-natural-oak-craftsmanship',
        dateLabel: 'April 28, 2026',
        image: `${assetBase}/news-1.jpg`,
        excerpt: 'Our Oak 3-layer flooring (AC-27), featuring a 4mm top layer, hand-scraped and smoked surface, and wax oil finish, combines natural aesthetics with structural stability. Designed with a click system for efficient installation, it is suitable for modern residential and commercial applications.',
        body: [
          'Our Oak 3-layer flooring (AC-27), featuring a 4mm top layer, hand-scraped and smoked surface, and wax oil finish, combines natural aesthetics with structural stability.',
          'Designed with a click system for efficient installation, it is suitable for modern residential and commercial applications where natural character and reliable performance both matter.'
        ]
      },
      {
        title: 'The Warmth of Home, One Floor at a Time',
        slug: 'the-warmth-of-home-one-floor-at-a-time',
        dateLabel: 'April 24, 2026',
        image: `${assetBase}/news-2.jpg`,
        excerpt: 'Create a warm and cozy home with natural wood flooring. Wood flooring adds natural texture, soft tones, and a comfortable feeling underfoot, making any space feel more inviting and relaxing.',
        body: [
          'Create a warm and cozy home with natural wood flooring. Wood flooring adds natural texture, soft tones, and a comfortable feeling underfoot, making any space feel more inviting and relaxing.',
          'Whether for modern, minimalist, or natural interiors, wood flooring is always a timeless choice. We offer a wide range of wood flooring options, with customizable sizes, finishes, and colors for different projects.'
        ]
      },
      {
        title: '9 Wood Flooring Surface Finishes: Which One Is Best for Your Home',
        slug: '9-wood-flooring-surface-finishes-which-one-is-best-for-your-home',
        dateLabel: 'April 22, 2026',
        image: `${assetBase}/news-3.jpg`,
        excerpt: 'Surface finish determines how the floor looks, how it feels underfoot, and how it should be maintained. Brushing, smoking, oiling, lacquering, and hand scraping each solve a different design problem.',
        body: [
          'Surface finish determines how the floor looks, how it feels underfoot, and how it should be maintained.',
          'Brushing, smoking, oiling, lacquering, and hand scraping each solve a different design problem. The right choice depends on traffic, maintenance expectations, and the mood you want the room to carry.'
        ]
      },
      {
        title: 'European Oak, Wide Planks and Herringbone Lead 2026 Design Trends',
        slug: 'european-oak-wide-planks-and-herringbone-lead-2026-design-trends',
        dateLabel: 'April 08, 2026',
        image: `${assetBase}/news-4.jpg`,
        excerpt: 'Premium residential clients continue to ask for natural oak, wider boards, and layouts with a clearer design signature. The strongest direction is quiet luxury rather than decorative excess.',
        body: [
          'Premium residential clients continue to ask for natural oak, wider boards, and layouts with a clearer design signature.',
          'Wide planks reduce visual interruptions and help open rooms feel calmer. Herringbone and chevron remain useful when the floor needs to carry more identity without losing material honesty.'
        ]
      },
      {
        title: 'Sustainability Becomes a Baseline Requirement Across Premium Flooring',
        slug: 'sustainability-becomes-a-baseline-requirement-across-premium-flooring',
        dateLabel: 'April 08, 2026',
        image: `${assetBase}/news-1.jpg`,
        excerpt: 'Certification, traceability, and responsible sourcing are no longer optional talking points in premium wood flooring projects.',
        body: [
          'Certification, traceability, and responsible sourcing are no longer optional talking points in premium wood flooring projects.',
          'Clients increasingly expect FSC-backed supply chains, transparent factory standards, and products that can be specified with confidence for both residential and commercial programs.'
        ]
      },
      {
        title: "Europe's Hardwood Flooring Market Set for Decade of Steady Growth",
        slug: 'europes-hardwood-flooring-market-set-for-decade-of-steady-growth',
        dateLabel: 'April 08, 2026',
        image: `${assetBase}/news-2.jpg`,
        excerpt: 'Demand for engineered hardwood, wide planks, and design-led formats continues to expand across European residential and hospitality markets.',
        body: [
          'Demand for engineered hardwood, wide planks, and design-led formats continues to expand across European residential and hospitality markets.',
          'Suppliers who can combine stable production, finish flexibility, and reliable logistics are best positioned to support wholesalers and project teams through the next cycle of growth.'
        ]
      },
      {
        title: 'Sustainability in Focus: FSC Certification and Responsible Wood Sourcing',
        slug: 'sustainability-in-focus-fsc-certification-and-responsible-wood-sourcing',
        dateLabel: 'March 31, 2026',
        image: `${assetBase}/news-3.jpg`,
        excerpt: 'Responsible sourcing is becoming a core part of how clients evaluate flooring partners, not just a supporting detail in the brochure.',
        body: [
          'Responsible sourcing is becoming a core part of how clients evaluate flooring partners, not just a supporting detail in the brochure.',
          'FSC certification helps teams specify wood floors with clearer environmental accountability while still prioritizing grain character, dimensional stability, and long-term performance.'
        ]
      },
      {
        title: 'Online Hardwood Flooring Sales Surge as Buyers Seek Inspiration First',
        slug: 'online-hardwood-flooring-sales-surge-as-buyers-seek-inspiration-first',
        dateLabel: 'March 31, 2026',
        image: `${assetBase}/news-4.jpg`,
        excerpt: 'More buyers start with visual references, finish comparisons, and layout ideas before they move into specification and sampling.',
        body: [
          'More buyers start with visual references, finish comparisons, and layout ideas before they move into specification and sampling.',
          'That shift makes strong product storytelling, case references, and finish education essential for brands that want to stay useful earlier in the decision process.'
        ]
      }
    ],
    videos: [
      {
        poster: `${assetBase}/news-1.jpg`,
        video: newsVideo(1),
        alt: 'STRONGOVA flooring video 1'
      },
      {
        poster: `${assetBase}/news-2.jpg`,
        video: newsVideo(2),
        alt: 'STRONGOVA flooring video 2'
      },
      {
        poster: `${assetBase}/news-3.jpg`,
        video: newsVideo(3),
        alt: 'STRONGOVA flooring video 3'
      },
      {
        poster: `${assetBase}/news-4.jpg`,
        video: newsVideo(4),
        alt: 'STRONGOVA flooring video 4'
      },
      {
        poster: `${assetBase}/news-1.jpg`,
        video: newsVideo(5),
        alt: 'STRONGOVA flooring video 5',
        featured: true
      }
    ]
  },
  coloursPage: {
    eyebrow: 'NATURALLY COLOURS',
    title: 'Colours',
    intro: 'STRONGOVA natural wood floors not only impress with exceptional stability and health-promoting properties but also with an impressive spectrum of colors from light to dark.',
    lead: 'The wide range of colors of STRONGOVA natural wood floors',
    patternImage: `${assetBase}/colour-light.jpg`,
    heroImage: `${assetBase}/colours-hero.jpg`,
    families: [
      {
        title: 'Light Wood Floors',
        image: `${assetBase}/colour-light.jpg`,
        body: 'Nordic, soft, and spatially open. These finishes keep rooms bright and let grain detail do the work.',
        href: '/products-list/light-wood-floors',
        slug: 'light-wood-floors',
        tone: 'Bright / Nordic / calm',
        bestFor: 'Plank, chevron, oversized plank'
      },
      {
        title: 'Dark Wood Floors',
        image: `${assetBase}/colour-dark.jpg`,
        body: 'Richer and more dramatic tones for hospitality, formal residences, and spaces that want more contrast.',
        href: '/products-list/dark-wood-floors',
        slug: 'dark-wood-floors',
        tone: 'Deep / formal / expressive',
        bestFor: 'Herringbone, parquet, plank'
      }
    ],
    notes: [
      'The wide range of colors of STRONGOVA natural wood floors adds character and personality to any ambiance.',
      'The natural, silky matte surface reflects the unique character of the wood without artificial alteration.',
      'In the portfolio, you will find only shades and expressions that closely follow the original appearance of woods. Additionally, we completely avoid artificial, chemical additives.'
    ],
    decisionBands: [
      { label: 'Light conditions', value: 'Test under project lighting' },
      { label: 'Texture effect', value: 'Brushing changes contrast' },
      { label: 'Sheen', value: 'Matte reads more natural' },
      { label: 'Sampling', value: 'Approve physical boards' }
    ]
  },
  colourDetails: {
    'light-wood-floors': {
      title: 'Light Wood Floors',
      eyebrow: 'Colours',
      heroImage: `${assetBase}/colour-light.jpg`,
      intro: 'Light wood floors are the airy side of the range: cleaner, brighter, and easier to pair with restrained architecture, Nordic palettes, and interior schemes that want more reflected light.',
      principles: [
        'Useful when the room should feel visually larger and more open.',
        'Grain and brushing still matter, but the overall read stays soft and calm.',
        'A strong fit for oak-led residential projects, hospitality suites, and contemporary family homes.'
      ],
      species: [
        { name: 'Natural Oak', note: 'Balanced grain and an easy, familiar warmth.' },
        { name: 'White Oiled Oak', note: 'A cooler, more Nordic direction with extra brightness.' },
        { name: 'Ash-led light tones', note: 'Livelier grain for spaces that want more visible movement.' },
        { name: 'Soft brushed surfaces', note: 'Keeps the palette tactile without making it busy.' }
      ],
      finishLogic: [
        { title: 'Best product formats', body: 'Plank, oversized plank, and chevron make light tones feel open and architectural.' },
        { title: 'Lighting behavior', body: 'Natural daylight makes pale oils read cleaner, while warm artificial lighting brings out honey undertones.' },
        { title: 'Texture guidance', body: 'Soft brushing is usually enough; too much texture can make a light floor busier than intended.' }
      ],
      specNotes: [
        { label: 'Tone direction', value: 'Natural, white oil, pale smoked' },
        { label: 'Best sheen', value: 'Matte / low sheen' },
        { label: 'Design fit', value: 'Nordic, minimal, wellness-led' },
        { label: 'Sampling note', value: 'Check under real daylight' }
      ],
      pairings: ['Scandinavian interiors', 'Minimal residences', 'Calm hospitality rooms', 'Natural stone and matte metal palettes'],
      gallery: [`${assetBase}/colour-light.jpg`, `${assetBase}/product-plank.jpg`, `${assetBase}/product-chevron.jpg`, `${assetBase}/ref-japan.jpg`]
    },
    'dark-wood-floors': {
      title: 'Dark Wood Floors',
      eyebrow: 'Colours',
      heroImage: `${assetBase}/colour-dark.jpg`,
      intro: 'Dark wood floors bring density, contrast, and formality. They tend to anchor a room more aggressively, which makes them powerful in premium residential work and hospitality spaces with a moodier brief.',
      principles: [
        'Best when the floor is expected to add depth and visual gravity.',
        'Works especially well with brass, stone, leather, and warmer artificial lighting.',
        'A good choice for statement interiors where a pale floor would feel too quiet.'
      ],
      species: [
        { name: 'Smoked Oak', note: 'Deepened colour with familiar oak structure still visible.' },
        { name: 'Walnut-like directions', note: 'Richer brown expression for more formal interiors.' },
        { name: 'Thermally treated tones', note: 'Darker character without abandoning natural wood cues.' },
        { name: 'Brushed and oiled finishes', note: 'Helps darker floors keep texture instead of going flat.' }
      ],
      finishLogic: [
        { title: 'Best product formats', body: 'Herringbone, parquet, and classic planks carry darker tones with more richness and definition.' },
        { title: 'Lighting behavior', body: 'Warm lighting adds depth, while weak daylight can make dark floors feel heavier.' },
        { title: 'Texture guidance', body: 'Brushing and oiling help darker colors keep visible grain instead of reading like a flat coating.' }
      ],
      specNotes: [
        { label: 'Tone direction', value: 'Smoked oak, walnut brown, deep natural' },
        { label: 'Best sheen', value: 'Matte or satin' },
        { label: 'Design fit', value: 'Hospitality, formal, luxury residential' },
        { label: 'Sampling note', value: 'Check dust and contrast behavior' }
      ],
      pairings: ['Luxury lounges', 'Boutique hotels', 'Formal dining areas', 'Dark stone and textured wall finishes'],
      gallery: [`${assetBase}/colour-dark.jpg`, `${assetBase}/product-herringbone.jpg`, `${assetBase}/product-parquet.jpg`, `${assetBase}/ref-germany-2.jpg`]
    }
  },
  qualityPage: {
    hero: {
      pretitle: 'MORE THAN JUST OPTICS',
      title: 'Our',
      titleBold: 'Quality',
      image: qualityAsset('hero.jpg')
    },
    introParagraphs: [
      'Compared with PVC flooring or carpets, solid wood flooring offers a richer experience. It is more aesthetically pleasing and immersive, making people feel as if they are in the depths of nature.',
      'However, not all woods are the same.',
      'To provide high-quality solid wood flooring, STRONGOVA has established a strict screening and processing system, delivering premium solid wood flooring to its high-end customers. May everyone who steps on STRONGOVA flooring feel as happy and carefree as a child playing in nature.'
    ],
    teasersRow1: [
      { label: 'ORIGIN', image: qualityAsset('teaser-origin.jpg'), anchor: 'Origin' },
      { label: 'INGREDIENTS', image: qualityAsset('teaser-ingredients.jpg'), anchor: 'ingredients' },
      { label: 'SURFACE', image: qualityAsset('teaser-surface.jpg'), anchor: 'Surface' },
      { label: 'EFFECT', image: qualityAsset('teaser-effect.jpg'), anchor: 'Effect' },
      { label: 'STRUCTURE', image: qualityAsset('teaser-structure.jpg'), anchor: 'Structure' },
      { label: 'INSTALLATION', image: qualityAsset('teaser-installation.jpg'), anchor: 'Installation' }
    ],
    teasersRow2: [
      { label: 'COLOR', image: qualityAsset('teaser-color.jpg'), anchor: 'Color' },
      { label: 'FORMATS', image: qualityAsset('teaser-formats.jpg'), anchor: 'Formats' },
      { label: 'CARE', image: qualityAsset('teaser-care.jpg'), anchor: 'Care' },
      { label: 'DISPOSAL', image: qualityAsset('teaser-disposal.jpg'), anchor: 'Disposal' },
      { label: 'DISPOSAL', image: qualityAsset('teaser-disposal-2.jpg'), anchor: 'Disposal' }
    ],
    origin: {
      id: 'Origin',
      title: 'The Origin of the Wood',
      paragraphs: [
        'Responsible use of resources secures the future of us all. The story of a wooden floor does not begin in a specialist shop, but in the forest. As an environmentally conscious natural wood flooring manufacturer, STRONGOVA sources the wood for its products from sustainable forestry in Europe.',
        'The traditional family business attaches great importance to transparency and therefore manufactures exclusively in Austria: from the delivery of the wood to the finished parquet floor, everything is done in-house. This is how STRONGOVA ensures the high quality of its floors in the long term.'
      ],
      images: {
        large: qualityAsset('origin-lg.jpg'),
        portrait: qualityAsset('origin-portrait.jpg'),
        small: qualityAsset('origin-sm.jpg')
      }
    },
    ingredients: {
      id: 'ingredients',
      number: 'number 2',
      title: 'The Ingredients',
      paragraphs: [
        'Many manufacturers use substances such as plasticizers, formaldehyde or volatile organic compounds (VOCs) in the production of their floor coverings, which together are harmful to health.',
        'In contrast, STRONGOVA\'s natural wood floors are completely free of harmful substances and follow the credo that less is more. Wood, white glue and oil - that\'s all you need for a healthy living floor.',
        'The white glue consists of 100 percent natural ingredients such as chalk and vinegar. The STRONGOVA wood floor oil is based on linseed oil and also contains no chemical additives.'
      ],
      image: qualityAsset('ingredients.jpg')
    },
    surface: {
      id: 'Surface',
      number: 'number 3',
      title: 'The Surface',
      paragraphs: [
        'The treatment of the plank surface has a major impact on the quality and durability of the floor.',
        'Varnishes and wax layers seal the surface and prevent the wood from developing its positive properties.',
        'Even with UV-oiled surfaces, a dense, lacquer-like film forms during drying due to the intensive exposure to ultraviolet light.',
        'This is why STRONGOVA uses an oxidatively oiled surface to finish its floors: the oiled planks are slowly air-dried so that the oil can penetrate deep into the wood. This is the only way to keep the floor open-pored and unaltered.'
      ],
      image: qualityAsset('surface.jpg')
    },
    effect: {
      id: 'Effect',
      number: 'Number 4',
      title: 'The Effect on Body and Space',
      items: [
        {
          subtitle: 'People and animals live and work directly on wood.',
          title: 'FEELING',
          image: qualityAsset('effect-feeling.jpg')
        },
        {
          subtitle: 'The open-pored surface cleans the room air.',
          title: 'ROOM CLIMATE',
          image: qualityAsset('effect-climate.jpg')
        },
        {
          subtitle: 'The floorboards are always warm and pleasant to the touch.',
          title: 'BAREFOOT',
          image: qualityAsset('effect-barefoot.jpg')
        }
      ]
    },
    structure: {
      id: 'Structure',
      number: 'Number 5',
      title: 'The Plank Structure',
      paragraphs: [
        'The plank structure determines the stability and durability of the floor.',
        'Solid parquet consists of the same piece of wood over its entire thickness. However, this means that the individual planks warp more quickly when they absorb and release moisture. In contrast, multi-layer parquet made from different layers of wood offers the necessary stability.'
      ],
      image: qualityAsset('structure.jpg'),
      note: 'Planks from STRONGOVA are particularly robust thanks to their symmetrical structure of three solid wood layers. With top and back layers made from the same type of wood and the same thermal treatment, the natural movement of the wood is greatly reduced - perfect for underfloor heating.'
    },
    installation: {
      id: 'Installation',
      number: 'Number 6',
      title: 'The Installation Types',
      paragraphs: [
        'The symmetrical plank structure also means that there are several installation methods, offering solutions and flexibility for renovations and modernizations in particular:'
      ],
      list: [
        'Full-surface gluing',
        'Partial gluing',
        'Nails/screws on upholstered wood',
        'Laying on boards',
        'Floating installation'
      ],
      image: qualityAsset('installation.jpg')
    },
    color: {
      id: 'Color',
      number: 'number 7',
      title: 'The Color',
      paragraphs: [
        'Individual, unadulterated and always based on nature.',
        'Natural wood floors from STRONGOVA not only impress with their inner values: they also present themselves in various appealing designs and color variations.',
        'The nine different types of wood fit into any interior design style, even in their naturally treated state - whether modern, classic or rustic. The STRONGOVA Vulcano thermo treatment gives the European wood the exotic character of tropical wood. Light, Nordic concepts, on the other hand, often rely on white or gray oiled planks.'
      ],
      cta: { label: 'Everything about our colors', to: '/colours' },
      galleryRow1: [
        qualityAsset('color-1.jpg'),
        qualityAsset('color-2.jpg'),
        qualityAsset('color-3.jpg'),
        qualityAsset('color-4.jpg'),
        qualityAsset('color-5.jpg')
      ],
      galleryRow2: [
        qualityAsset('color-6.jpg'),
        qualityAsset('color-7.jpg'),
        qualityAsset('color-8.jpg'),
        qualityAsset('color-9.jpg'),
        qualityAsset('color-10.jpg')
      ]
    },
    formats: {
      id: 'Formats',
      number: 'Number 8',
      title: 'The Formats',
      paragraphs: [
        'A modern interpretation of classics.',
        'The interplay between plank structure, surface and our hunger for innovation creates a broad spectrum of designs. From planks as classic country house planks, renovation planks or room-length planks to modern-interpreted formats such as herringbone, chevron or hexagon, through to end grain floors and Parquet panel - we offer flexibility for every project.'
      ],
      cta: { label: 'Our Formats', to: '/products' },
      products: [
        // { title: 'Plank', image: qualityAsset('format-plank.jpg'), to: '/products-list/plank' },
        // { title: 'Herringbone Plank 90°', image: qualityAsset('format-herringbone.jpg'), to: '/products-list/herringbone-plank-90deg' },
        // { title: 'Chevron Plank 45°', image: qualityAsset('format-chevron.jpg'), to: '/products-list/chevron-plank-45deg' },
        // { title: 'Parquet', image: qualityAsset('format-parquet.jpg'), to: '/products-list/parquet' }
      ]
    },
    care: {
      id: 'Care',
      number: 'Number 9',
      title: 'Maintenance',
      paragraphs: [
        'As easy as washing your hands.',
        'To keep the floor looking its best even after years of use, care and cleaning are required. Here too, the open-pored surface of STRONGOVA natural wood floors proves its worth: dirt and stains can be easily washed out with warm water'
      ],
      cta: { label: 'Everything about care', to: '/care' },
      image: qualityAsset('care.jpg')
    },
    disposal: {
      id: 'Disposal',
      number: 'Number 10',
      title: 'The Disposal',
      paragraphs: [
        'Not hazardous waste, but completely compostable. Even the most durable wooden floor comes to an end at some point. The only question then is how to dispose of it.',
        'While a lacquered floor is often considered hazardous waste due to its sometimes toxic ingredients, STRONGOVA natural wood floors are recyclable products. They contain no chemical additives - no lacquers or other petroleum products - but only natural ingredients and are therefore even compostable.'
      ],
      image: qualityAsset('disposal.jpg')
    }
  },
  carePage: {
    hero: {
      pretitle: 'A FLOOR FOR GENERATIONS',
      title: 'THE CARE',
      image: careAsset('hero.jpg')
    },
    guide: {
      pretitle: "It's that simple",
      title: 'Wiping a mafi Natural Wood Floor',
      intro:
        'First clean the parquet floor with a vacuum cleaner. Mopping parquet is almost as easy as vacuuming. All you need is two buckets, a cotton mop and a container of mafi wood floor soap. We recommend these six steps for parquet cleaning and care:',
      steps: [
        'Fill both buckets with warm water.',
        'Add the appropriate mafi wood floor soap to one bucket (125 ml soap to 5 l water). The two-bucket principle ensures that the clean soap water does not mix with the dirty water.',
        'Spread the soapy water mixture on the floor with a cotton mop.',
        'After a short reaction time, remove the excess water with the cotton mop and wash out in a second bucket. The mafi wood floor soap loosens the dirt from the pores and the loosened dirt is removed from the floor by picking it up with the mop.',
        'Then wash the cotton mop in the second bucket with clear water.',
        'Then repeat steps 3-5 for the entire floor surface.',
        'In principle, mafi natural wood floors can be mopped very damp. Only the floors with Vulcano thermal treatment should only be wiped with a damp cloth.'
      ],
      frequencyTitle: 'How often should parquet be mopped?',
      frequencyBody:
        'For normal use in a private household, we recommend cleaning the parquet approx. every four weeks. In between, weekly vacuuming is sufficient.'
    },
    video: {
      pretitle: 'Video',
      title: 'Regular Soap Care',
      poster: careAsset('video-poster.jpg'),
      src: ''
    },
    contact: {
      title: 'We are always happy to help',
      image: careAsset('contact.jpg'),
      countries: [
        'Austria', 'Germany', 'Italy', 'Switzerland', 'Egypt', 'Albania', 'Argentina',
        'Australia', 'Belgium', 'Bulgaria', 'China', 'Denmark', 'Estonia', 'Finland',
        'France', 'Georgia', 'Gibraltar', 'Greece', 'Guadeloupe', 'Hong Kong SAR China',
        'India', 'Ireland', 'Iceland', 'Israel', 'Japan', 'Canada', 'Kazakhstan', 'Qatar',
        'Croatia', 'Latvia', 'Lebanon', 'Lithuania', 'Luxembourg', 'Malta', 'Marshall Islands',
        'Mauritius', 'Mexico', 'Monaco', 'Netherlands', 'Norway', 'Poland', 'Portugal',
        'Rwanda', 'Romania', 'Russia', 'Sweden', 'Serbia', 'Singapore', 'Slovakia',
        'Slovenia', 'Spain', 'South Korea', 'Taiwan', 'Czechia', 'Türkiye', 'Ukraine',
        'Hungary', 'United States', 'United Kingdom', 'Cyprus', 'Other country'
      ]
    }
  },
  casesPage: {
    hero: {
      pretitle: 'High-quality natural wood solutions',
      title: 'The Cases',
      video: '',
      poster: casesAsset('case-01.jpg')
    },
    items: [
      { title: 'Germany case', image: casesAsset('case-01.jpg') },
      { title: 'Germany case', image: casesAsset('case-02.jpg') },
      { title: 'China case', image: casesAsset('case-03.jpg') },
      { title: 'Germany case', image: casesAsset('case-04.jpg') },
      { title: 'Korea case', image: casesAsset('case-05.jpg') },
      { title: 'USA case', image: casesAsset('case-06.jpg') },
      { title: 'Germany case', image: casesAsset('case-07.jpg') },
      { title: 'Japan case', image: casesAsset('case-08.jpg') },
      { title: 'China case', image: casesAsset('case-09.jpg') },
      { title: 'Korea case', image: casesAsset('case-10.jpg') }
    ]
  },
  caseDetails: {
    'germany-case': {
      title: 'Germany case',
      country: 'Germany',
      eyebrow: 'Reference',
      heroImage: `${assetBase}/ref-germany-1.jpg`,
      subtitle: 'Solid wood three-layer flooring',
      summary: 'This Germany reference centers on a herringbone hardwood program with UV lacquer, saw-mark and smoked surface options, and a finish profile aimed at stylish residential use.',
      notes: [
        'A strong example of patterned wood flooring used to elevate a domestic interior without losing warmth.',
        'The smoked and saw-mark surface treatments add character while keeping the composition commercially elegant.',
        'It reads as a premium reference for clients drawn to expressive but still familiar European interiors.'
      ],
      specs: [
        { label: 'Floor type', value: 'Solid wood three-layer flooring' },
        { label: 'Pattern cue', value: 'Herringbone-driven layout' },
        { label: 'Surface', value: 'UV lacquer with saw-mark or smoked options' },
        { label: 'Project feel', value: 'Warm, stylish, residential' },
        { label: 'Related product', value: 'Herringbone Plank 90°' },
        { label: 'Colour direction', value: 'Smoked warm oak' },
        { label: 'Use scenario', value: 'Premium residential rooms' },
        { label: 'Specification cue', value: 'Pattern alignment and tone control' }
      ],
      outcomes: [
        { title: 'Stronger room identity', body: 'The patterned layout gives the space a more designed feeling without making it visually noisy.' },
        { title: 'Warm premium tone', body: 'Smoked and saw-mark surface options add depth while keeping the floor recognizably natural.' },
        { title: 'Reliable project reference', body: 'The case works well for clients who want European residential warmth with a refined finish.' }
      ],
      gallery: [`${assetBase}/ref-germany-1.jpg`, `${assetBase}/ref-germany-2.jpg`, `${assetBase}/case-germany-3.jpg`, `${assetBase}/case-germany-4.jpg`]
    },
    'china-case': {
      title: 'China case',
      country: 'China',
      eyebrow: 'Reference',
      heroImage: `${assetBase}/ref-china.jpg`,
      subtitle: 'Herringbone 90° three-layer flooring',
      summary: 'This China project positions herringbone as a statement of taste and individuality, using UV lacquer, saw-mark texture, and AB-grade multi-layer engineered construction for a refined interior result.',
      notes: [
        'The project leans into a more decorative visual language while keeping the product technically robust.',
        'A good local reference for clients who want a noticeably designed floor rather than a quiet background surface.',
        'It shows how patterned formats can still feel polished and high-end in a contemporary setting.'
      ],
      specs: [
        { label: 'Floor type', value: 'Herringbone 90° three-layer flooring' },
        { label: 'Grade', value: 'AB-grade engineered hardwood' },
        { label: 'Surface', value: 'UV lacquer with saw-mark texture' },
        { label: 'Project feel', value: 'Artful, sophisticated, polished' },
        { label: 'Related product', value: 'Herringbone Plank 90°' },
        { label: 'Colour direction', value: 'Medium natural oak' },
        { label: 'Use scenario', value: 'Premium home interior' },
        { label: 'Specification cue', value: 'AB grade and saw-mark surface' }
      ],
      outcomes: [
        { title: 'Visible design character', body: 'The herringbone pattern makes the floor part of the interior identity instead of a quiet background.' },
        { title: 'Technical balance', body: 'AB-grade engineered construction keeps the product visually refined and structurally practical.' },
        { title: 'Polished local reference', body: 'The case is useful for buyers looking for high-end residential proof in the China market.' }
      ],
      gallery: [`${assetBase}/ref-china.jpg`, `${assetBase}/case-china-2.jpg`, `${assetBase}/product-herringbone.jpg`, `${assetBase}/quality-feeling.jpg`]
    },
    'korea-case': {
      title: 'Korea case',
      country: 'Korea',
      eyebrow: 'Reference',
      heroImage: `${assetBase}/ref-korea.jpg`,
      subtitle: 'Herringbone 90° three-layer flooring',
      summary: 'This Korea case highlights a natural-toned herringbone floor with UV lacquer, brushed texture, and AB-grade quality, resulting in a space that feels organic, calm, and easy to live with.',
      notes: [
        'The strength here is restraint: natural wood tone, visible texture, and a relaxed upscale finish.',
        'It is a persuasive reference for clients who want warmth and pattern without heavy visual drama.',
        'The project shows how herringbone can feel soft and breathable, not only formal.'
      ],
      specs: [
        { label: 'Floor type', value: 'Herringbone 90° three-layer flooring' },
        { label: 'Grade', value: 'AB-grade quality' },
        { label: 'Surface', value: 'UV lacquer with brushed texture' },
        { label: 'Project feel', value: 'Natural, relaxing, organic' },
        { label: 'Related product', value: 'Herringbone Plank 90°' },
        { label: 'Colour direction', value: 'Light natural tone' },
        { label: 'Use scenario', value: 'Calm residential interior' },
        { label: 'Specification cue', value: 'Brush texture and soft tone' }
      ],
      outcomes: [
        { title: 'Soft patterned result', body: 'The floor keeps pattern interest while staying calm enough for everyday living.' },
        { title: 'Natural material read', body: 'Brushing and lighter tone help the wood feel organic and less formal.' },
        { title: 'Good comfort reference', body: 'The case supports clients looking for warmth, restraint, and relaxed premium interiors.' }
      ],
      gallery: [`${assetBase}/ref-korea.jpg`, `${assetBase}/case-korea-2.jpg`, `${assetBase}/colour-light.jpg`, `${assetBase}/product-herringbone.jpg`]
    },
    'usa-case': {
      title: 'USA case',
      country: 'United States',
      eyebrow: 'Reference',
      heroImage: `${assetBase}/ref-usa.jpg`,
      subtitle: 'Herringbone 90° three-layer flooring',
      summary: 'The USA project uses a light-toned natural wood palette with natural oil and brushed finishing, creating a calm interior mood built around authentic grain and a more relaxed luxury sensibility.',
      notes: [
        'The light-toned direction makes this one especially relevant to clients looking for wellness-coded interiors.',
        'Natural oil and brushing let the wood feel tactile rather than overly sealed.',
        'A useful benchmark for premium homes and hospitality suites that want softness more than drama.'
      ],
      specs: [
        { label: 'Floor type', value: 'Herringbone 90° three-layer flooring' },
        { label: 'Collection tone', value: 'Light natural wood palette' },
        { label: 'Surface', value: 'Natural oil with brushed finish' },
        { label: 'Project feel', value: 'Soothing, calm, lived-in luxury' },
        { label: 'Related product', value: 'Herringbone Plank 90°' },
        { label: 'Colour direction', value: 'Light wood floor' },
        { label: 'Use scenario', value: 'Wellness-led residential space' },
        { label: 'Specification cue', value: 'Natural oil and low sheen' }
      ],
      outcomes: [
        { title: 'Lighter luxury tone', body: 'The pale natural palette makes the interior feel open, calm, and easy to live with.' },
        { title: 'Tactile surface', body: 'Natural oil and brushing keep the wood surface believable underfoot.' },
        { title: 'Useful trend proof', body: 'The project demonstrates the demand for light, wellness-coded flooring in premium homes.' }
      ],
      gallery: [`${assetBase}/ref-usa.jpg`, `${assetBase}/colour-light.jpg`, `${assetBase}/product-herringbone.jpg`, `${assetBase}/quality-origin.jpg`]
    },
    'japan-case': {
      title: 'Japan case',
      country: 'Japan',
      eyebrow: 'Reference',
      heroImage: `${assetBase}/ref-japan.jpg`,
      subtitle: 'Chevron 45° three-layer flooring',
      summary: 'This Japan case shifts from herringbone to chevron, pairing a fresh elegant tone with UV lacquer and brushed finishing to create a space that feels restorative, precise, and visually composed.',
      notes: [
        'Chevron gives the project a more directional and architectural rhythm than the herringbone references.',
        'The fresher hue keeps the overall result light even though the geometry is strong.',
        'It is a sharp example for clients who want a more editorial pattern language.'
      ],
      specs: [
        { label: 'Floor type', value: 'Chevron 45° three-layer flooring' },
        { label: 'Pattern cue', value: 'Directional chevron layout' },
        { label: 'Surface', value: 'UV lacquer with brushed finish' },
        { label: 'Project feel', value: 'Elegant, fresh, restorative' },
        { label: 'Related product', value: 'Chevron Plank 45°' },
        { label: 'Colour direction', value: 'Fresh light oak' },
        { label: 'Use scenario', value: 'Design-led interior' },
        { label: 'Specification cue', value: 'Chevron point alignment' }
      ],
      outcomes: [
        { title: 'Architectural direction', body: 'Chevron adds a stronger directional rhythm and makes the room feel more composed.' },
        { title: 'Fresh visual balance', body: 'The lighter tone keeps the geometry from feeling heavy.' },
        { title: 'Editorial reference', body: 'The case works well for designers who want a more intentional pattern language.' }
      ],
      gallery: [`${assetBase}/ref-japan.jpg`, `${assetBase}/product-chevron.jpg`, `${assetBase}/colour-light.jpg`, `${assetBase}/quality-feeling.jpg`]
    }
  },
  siteSettings: {
    siteName: 'STRONGOVA',
    seoTitle: 'STRONGOVA',
    seoDescription: 'STRONGOVA ecological wood flooring.',
    seoKeywords: 'STRONGOVA, wood flooring, ecological wood',
    logoImage: '',
    faviconImage: '',
    shareImage: '',
    footerText: 'CopyRight © 2005-2025 STRONGOVA .All right reserved',
    footerDesignedBy: 'Designed By:SENJU',
    privacyPolicyTitle: 'Privacy Policy',
    privacyPolicyContent: [
      'STRONGOVA respects your privacy and is committed to protecting the personal information you share with us.',
      'We use submitted contact and inquiry information only to respond to your requests, provide product support, and improve our services.',
      'We do not sell your personal information. If you need to update or remove information you have submitted, please contact us by email.'
    ].join('\n\n'),
    contactEmail: 'STRONGOVA@strongova.com',
    contactPhone: '+86 15668650333',
    factoryAddressCn: 'NO.59 HAIXiang Road, Daweijia Street, Jinzhou District, Dalian City.',
    factoryAddressRs: 'Obrenovacki Put 237a, Baric',
    socialWhatsapp: '',
    socialInstagram: '',
    socialTiktok: '',
    socialFacebook: '',
    socialLinkedin: '',
    socialX: ''
  },
  searchData: {
    products: [],
    cases: [],
    articles: []
  },
  footer: {
    favorites: [
      { label: 'Products', href: '/products' },
      { label: 'Strength', href: '/strength' },
      { label: 'Knowledge', href: '/knowledge' },
      { label: 'Contact', href: '/contact' },
      { label: 'Privacy Policy', href: '/privacy-policy' }
    ],
    socials: ['WhatsApp', 'Instagram', 'TikTok', 'Facebook']
  },
  nav: [
    { label: 'Home', href: '/', target: 'home' },
    {
      label: 'Products',
      href: '/products',
      target: 'products',
      children: [
        { label: 'Natural Wood Floors', href: '/products' },
        { label: 'Plank', href: '/products-list/plank' },
        { label: 'Herringbone Plank 90°', href: '/products-list/herringbone-plank-90deg' },
        { label: 'Chevron Plank 45°', href: '/products-list/chevron-plank-45deg' },
        { label: 'Parquet', href: '/products-list/parquet' },
        { label: 'Oversized Plank', href: '/products-list/oversized-plank' },
        { label: 'Colours', href: '/colours' },
        { label: 'Light Wood Floors', href: '/products-list/light-wood-floors' },
        { label: 'Dark Wood Floors', href: '/products-list/dark-wood-floors' }
      ]
    },
    { label: 'Customize', href: '/customize', target: 'customize' },
    {
      label: 'Strength',
      href: '/strength',
      target: 'strength',
      children: [
        { label: 'Advantage', href: '/strength' },
        { label: 'Premium Quality', href: '/quality' }
        // { label: 'Cases', href: '/cases' }
      ]
    },
    {
      label: 'Knowledge',
      href: '/knowledge',
      target: 'knowledge',
      children: [
        { label: 'News', href: '/knowledge' },
        { label: 'Care', href: '/care' }
      ]
    },
    {
      label: 'Contact',
      href: '/contact',
      target: 'contact',
      children: [
        { label: 'Quote Quickly', href: '/contact?tab=quote' },
        { label: 'Sales Partner', href: '/contact?tab=partner' },
        { label: 'Factory', href: '/contact?tab=factory' }
      ]
    }
  ]
}
